import React, { Component } from 'react';




export default class HomeTitle extends Component {

    render() {

        return (
            <div className="Hometitle">
                <h3><span>{this.props.title}</span></h3>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/home/hometitle.jsx